import { Chip, Stack } from "@mui/material";
import React from "react";
import { GridValidRowModel } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

export type TableCellAlertSeverityProps = {
  data: GridValidRowModel;
};

const TableCellSubtitleSeverity: React.FC<TableCellAlertSeverityProps> = (props) => {
  const { t } = useTranslation();
  const value = props.data.value;
  let color: "default" | "primary" | "success" | "info" | "error" = "primary";
  let text = "";

  switch (value) {
    case 10:
      text = t("common:advise");
      break;
    case 50:
      color = "info";
      text = t("common:warning");
      break;
    case 100:
      color = "error";
      text = t("common:critical");
      break;
  }

  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Chip
          label={text}
          component="span"
          variant="outlined"
          color={color}
          sx={{ ml: 0.5, verticalAlign: "baseline" }}
        />
      </Stack>
    </Stack>
  );
};

export default TableCellSubtitleSeverity;
